// Category mapping for SwapX listings

export interface CategoryInfo {
  value: string;
  label: string;
  oldValues?: string[]; // For migration purposes
}

export const CATEGORIES: CategoryInfo[] = [
  { value: "clothing-shoes-accessories", label: "Clothing, Shoes & Accessories", oldValues: ["fashion"] },
  { value: "home-kitchen-dining", label: "Home, Kitchen & Dining" },
  { value: "furniture", label: "Furniture" },
  { value: "toys", label: "Toys" },
  { value: "electronics", label: "Electronics", oldValues: ["electronics"] },
  { value: "hair-beauty-personal-care", label: "Hair, Beauty & Personal Care" },
  { value: "baby", label: "Baby" },
  { value: "video-games", label: "Video Games" },
  { value: "movies-dvds", label: "Movies & DVDs" },
  { value: "music-cds", label: "Music & CDs" },
  { value: "books", label: "Books" },
  { value: "sports-outdoors", label: "Sports & Outdoors", oldValues: ["sports"] },
  { value: "trading-cards-collectibles", label: "Trading Cards & Collectibles", oldValues: ["collectibles"] },
  { value: "collectibles", label: "Collectibles (Graded & Certified)" },
  { value: "designer-fashion", label: "Designer Fashion" },
  { value: "art", label: "Art", oldValues: ["art"] },
  { value: "luxury-watches-jewelry", label: "Luxury Watches & Jewelry" },
  { value: "vehicles", label: "Vehicles" },
  { value: "other", label: "Other", oldValues: ["other"] },
];

export const getCategoryLabel = (value: string | null): string => {
  if (!value) return "Uncategorized";
  const category = CATEGORIES.find(c => c.value === value);
  return category?.label || value;
};

export const getCategoryValue = (label: string): string => {
  const category = CATEGORIES.find(c => c.label === label);
  return category?.value || "other";
};

// Old to new category mapping for migration
export const LEGACY_CATEGORY_MAP: Record<string, string> = {
  "electronics": "electronics",
  "collectibles": "trading-cards-collectibles",
  "fashion": "clothing-shoes-accessories",
  "sports": "sports-outdoors",
  "art": "art",
  "other": "other",
};

export const migrateLegacyCategory = (oldCategory: string | null): string => {
  if (!oldCategory) return "other";
  return LEGACY_CATEGORY_MAP[oldCategory] || "other";
};
